import { createPortal } from "react-dom";
import { useEffect, useState } from "react";

const getCSSVariablesFromClass = (className) => {
    const styles = {};
    for (const sheet of document.styleSheets) {
        try {
            for (const rule of sheet.cssRules) {
                if (rule.selectorText === className) {
                    for (const property of rule.style) {
                        if (property.startsWith('--')) {
                            styles[property] = rule.style.getPropertyValue(property).trim();
                        }
                    }
                }
            }
        } catch (e) {
            // Ignora errori di accesso a fogli di stile di dominio diverso
            console.warn(e);
        }
    }
    return styles;
};

const PiPWindow = ({ pipWindow, children, className, styles, onOpen, onResize }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        if (pipWindow && pipWindow.document?.head) {
            const pipRoot = pipWindow.document.documentElement;

            // Ottieni le variabili CSS dalla classe .starting-finance
            const classStyles = getCSSVariablesFromClass('.starting-finance');

            // Combina le variabili CSS passate tramite props con quelle della classe
            const combinedStyles = { ...classStyles, ...styles };

            // Applica tutte le variabili CSS al :root della finestra PiP
            Object.keys(combinedStyles).forEach((property) => {
                if (property.startsWith('--')) {
                    pipRoot.style.setProperty(property, combinedStyles[property]);
                }
            });

            const handleResize = () => {
                if (onResize) {
                    const width = pipWindow.innerWidth;
                    const height = pipWindow.innerHeight;
                    onResize( width, height );
                }
            };

            pipWindow.addEventListener('resize', handleResize);


            setMounted(true);

            onOpen(pipWindow.innerWidth, pipWindow.innerHeight);

            // Cleanup del listener quando il componente viene smontato
            return () => {
                pipWindow.removeEventListener('resize', handleResize);
            };
        }
    }, [pipWindow, styles, onResize]);

    if (!mounted) return null;

    return createPortal(
        <div className={className}>{children}</div>,
        pipWindow.document.body
    );
};

export default PiPWindow;